import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { useDeleteDocument } from '@/features/patient-record/hooks/useDocumentMutations';

import { ConfirmDeleteDialog } from '../_shared/ConfirmDeleteDialog';

interface DeleteDocumentDialogProps {
  readonly guid: string;
  readonly documentId: string;
  readonly onClose: () => void;
}

export function DeleteDocumentDialog({
  guid,
  documentId,
  onClose,
}: DeleteDocumentDialogProps): ReactElement {
  const { t } = useTranslation();
  const mutation = useDeleteDocument(guid);
  return (
    <ConfirmDeleteDialog
      title={t('patient.documents.deleteConfirmTitle')}
      message={t('patient.documents.deleteConfirmMessage')}
      confirmLabel={t('patient.documents.delete')}
      busy={mutation.isPending}
      onCancel={onClose}
      onConfirm={() => {
        mutation.mutate(documentId, {
          onSettled: onClose,
        });
      }}
    />
  );
}
